import React, { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";

function Row({ p, onDone }) {
  const [v, setV] = useState("");
  const save = async () => {
    try { await api.post(`/checks/missing-contacts/${p.id}`, p.need === "email" ? { email: v } : { whatsapp: v }); toast.success(`${p.name} mis à jour`); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Enregistrement impossible"); }
  };
  return (
    <div className="flex items-center gap-2 py-1.5 text-sm" data-testid={`missing-contact-${p.id}`}>
      <span className="w-36 truncate font-medium" title={p.name}>{p.name}</span>
      <span className="w-24 text-xs text-norea-textMuted">{p.dossiers} dossier{p.dossiers > 1 ? "s" : ""}</span>
      <input value={v} onChange={(e) => setV(e.target.value)} onKeyDown={(e) => e.key === "Enter" && v.trim() && save()} placeholder={p.need === "email" ? "email@poseur.fr" : "06 12 34 56 78"}
        className="flex-1 min-w-0 px-2 py-1 border border-norea-border rounded text-sm outline-none focus:border-norea-primary" data-testid={`missing-contact-input-${p.id}`} />
      <button onClick={save} disabled={!v.trim()} className="p-1.5 rounded bg-norea-primary text-white disabled:opacity-40" aria-label="Enregistrer" data-testid={`missing-contact-save-${p.id}`}><Check className="w-3.5 h-3.5" /></button>
    </div>
  );
}

export default function MissingContactsCard() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [items, setItems] = useState([]);
  const load = () => !isAdmin ? Promise.resolve() : api.get("/checks/missing-contacts").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, [isAdmin]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!isAdmin || !items.length) return null;
  const groups = [["whatsapp", "Régies sans WhatsApp"], ["email", "Sous-traitants poseurs sans email"]];
  return (
    <div className="card-flat p-5 mb-6" data-testid="missing-contacts-card">
      <h3 className="font-heading text-lg font-medium text-norea-text">Contacts manquants <span className="text-sm text-norea-textMuted">({items.length})</span></h3>
      <p className="text-xs text-norea-textMuted mt-1 mb-3">Complétez directement ici : l'annuaire est mis à jour et la ligne disparaît.</p>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-4">
        {groups.map(([need, title]) => items.some((p) => p.need === need) && (
          <div key={need}>
            <div className="text-xs font-medium text-norea-textMuted uppercase tracking-wider mb-1">{title}</div>
            <div className="divide-y divide-norea-border">{items.filter((p) => p.need === need).map((p) => <Row key={p.id} p={p} onDone={load} />)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
